import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import AssessmentCards from '../../components/ApplicantAssessment/AssessmentCards';
import './AssessmentListPage.css';

const AssessmentListPage: React.FC = () => {
  const { jobId } = useParams();
  return (
    <div className="assessmentListPage">
      <Grid container direction="column">
        <Typography variant="h4" fontWeight="bold" sx={{ marginBottom: '1rem', marginTop: '1rem' }}>
          Assessments
        </Typography>
        <AssessmentCards jobId={jobId} showSubmit={true} />
      </Grid>
    </div>
  );
};

export default AssessmentListPage;
